import $ from "jquery";
import { openSaveContactModal } from 'ui/add-contact-addressbook-modal';

function contactFieldSelector(fieldName, contactIndex) {
    return `input[name="caseBean.contacts[${contactIndex}].${fieldName}"]`;
}

function handleUndefinedAndEmpty(s) {
    return s === 'undefined' || s === undefined || $.trim(s).length === 0 ? '' : s + ' ';
}

function saveToAddressBook() {
    const contactIndex = $(this).data('index');
    const contactType = $(this).data('type');
    const companyName = handleUndefinedAndEmpty($(contactFieldSelector('companyName', contactIndex)).val());
    const department = handleUndefinedAndEmpty($(contactFieldSelector('department', contactIndex)).val());
    const givenName = handleUndefinedAndEmpty($(contactFieldSelector('givenName', contactIndex)).val());
    const middleName = handleUndefinedAndEmpty($(contactFieldSelector('middleName', contactIndex)).val());
    const surName = handleUndefinedAndEmpty($(contactFieldSelector('surname', contactIndex)).val());
    const title = $.trim(companyName + department + givenName + middleName + surName);
    openSaveContactModal(contactIndex, title, contactType);
}

$(() => {
    $('.saveToAddressBook').on('click', saveToAddressBook);
});
